import { OrderSourcesTable } from '@/components/features/order-source'

export const OrderSources = () => {
  return <OrderSourcesTable />
}
